module.exports = new __parcel__URL__("favicon-temp-csm.7aac7873.png").toString();